export const actionTypes = {
    SET_SUCCESS: "FEEDBACK:SET_SUCCESS"
};

export const feedbackSelectData = [
    {
        id: 0,
        name: "Работа сервиса"
    }
]

export enum userComplainEnum {
    Fake = 0,
    Nudes = 1,
    Inactive = 2,
    Aggressive = 3,
    Other = 4
}

export enum photoComplainEnum {
    Fake = 0,
    Nudes = 1,
    Other = 2
}